import { RxExclamationTriangle } from "react-icons/rx";

type FromErrorProps = {
  message?: string;
};

const FormError = (props: FromErrorProps) => {
  if (!props.message) return null;

  return (
    <div className="flex items-center gap-x-2 rounded-md bg-destructive/15 p-3 text-sm text-destructive">
      <RxExclamationTriangle className="size-4" />
      <p>{props.message}</p>
    </div>
  );
};

export default FormError;
